export default {
  "head": {
    "title": "链创未来——迅雷链技术沙龙"
  },
  "微信分享": {
    "标题": "关于迅雷链",
    "介绍": "迅雷链（Thunder Chain）是由迅雷旗下网心科技打造的超级区块链平台，是全球最大规模ToC区块链商业生态，赋能实体经济，致力于成为ToC现象级区块链应用的摇篮。\n",
    "图片": "https://static.geekbang.org/infoq/5badef47227d6.png?imageView2/0/w/800"
  },
  "导航栏": {
    "list": [
      {
        "name": "最新资讯",
        "link": "#toutiao",
        "是否显示": true
      },
      {
        "name": "沙龙动态",
        "link": "#news",
        "是否显示": true
      },
      {
        "name": "精华文章",
        "link": "#essays",
        "是否显示": true
      },
      {
        "name": "大会日程全概览",
        "link": "#schedule",
        "是否显示": false
      },
      {
        "name": "大咖与你相约",
        "link": "#speakers",
        "是否显示": false
      },
      {
        "name": "会场花絮",
        "link": "#live",
        "是否显示": false
      },
      {
        "name": "精彩瞬间聚焦",
        "link": "#image",
        "是否显示": true
      },
      {
        "name": "视频",
        "link": "#video",
        "是否显示": false
      },
      {
        "name": "合作伙伴",
        "link": "#partners",
        "是否显示": false
      },
      {
        "name": "相关新闻全播报",
        "link": "#relative",
        "是否显示": false
      },
      {
        "name": "关于",
        "link": "#about",
        "是否显示": true
      }
    ]
  },
  "banner": {
    "link": "https://open.onethingcloud.com/",
    "图片（pc）": "https://static.geekbang.org/infoq/5bbda173db249.png",
    "图片（mobile）": "https://static.geekbang.org/infoq/5bc080c8bf284.png"
  },
  "头条新闻": {
    "是否显示": true,
    "title": {
      "h1": "最新资讯",
      "h2": " Information"
    },
    "图片": "https://constatic.geekbang.org/infoq/5d142a0c1785b.png?imageView2/0/w/800",
    "right": {
      "标题": "链创未来——迅雷链技术沙龙（深圳站）",
      "介绍": "5G作为新一代移动通信技术，具备高速率、低延时和海量接入的特性。而区块链作为新一代互联网，其去中心化、交易信息隐私保护等特性可推动5G应用的高效发展。但是，近年来网络孤立性阻碍了不同区块链之间的协同操作，打破区块链网络通信壁垒成为了区块链技术与5G结合的重要问题。本次沙龙，我们邀请了迅雷链开放平台资深工程师以及中山大学数据科学与计算机学院教授，以区块链在通信领域的技术突破为基础，解读如何利用P2P网络构建...",
      "more": "了解详情>>",
      "link": "https://jinshuju.net/f/Fz57q1?x_field_1=gw"
    }
  },
  "实时报道": {
    "是否显示": true,
    "title": {
      "h1": "沙龙动态",
      "h2": "Dynamics Sharon "
    },
    "list": [
      {
        "排序": "91",
        "图片": "https://static.geekbang.org/infoq/5c0f8b6a270f0.png?imageView2/0/w/800",
        "title": "链创未来——迅雷链技术沙龙（北京站）",
        "description": "简介：2018 年 9 月 15 日下午，中关村创业大街的 3W 咖啡聚集了一群区块链开发者和爱好者。这里正在进行一场干货满满的迅雷链技术沙龙。我们将活动干货内容整理成文，帮助开发者了解迅雷链的技术内容和一些区块链的趋势和落地。",
        "link": "https://mp.weixin.qq.com/s/t0lugD9F7t78NZwbftvG5w",
        "tip": ""
      },
      {
        "排序": "82",
        "图片": "https://static.geekbang.org/infoq/5c0f88ea468bb.png?imageView2/0/w/800",
        "title": "链创未来——迅雷链技术沙龙（上海站）",
        "description": "简介：2018 年11月24日下午，上海长宁区的 Hello Coffee聚集了一群区块链开发者和爱好者。分别就区块链底层架构、数据存储、加密技术、DApp 现状进行深入浅出的主题分享。",
        "link": "https://mp.weixin.qq.com/s/KlkorAjSSlnQAzq1sq1A-Q",
        "tip": ""
      },
      {
        "排序": "73",
        "图片": "https://static.geekbang.org/infoq/5c26dc366523a.png?imageView2/0/w/800",
        "title": "链创未来——迅雷链技术沙龙（成都站）",
        "description": "区块链的极高安全性，具体是怎么做到的？ 目前的区块链研究和应用资料相对较少，查阅资料，不如与行业的领头人近距离聊聊，听听他们的研究思路和实践成果。",
        "link": "https://mp.weixin.qq.com/s/S2dxQDzSy7qPIcUvWNWFfA",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      }
    ]
  },
  "精华文章": {
    "是否显示": true,
    "title": {
      "h1": "精华文章",
      "h2": "Essays Of The Essence"
    },
    "list": [
      {
        "排序": "1",
        "图片": "https://static.geekbang.org/infoq/5bc07f6fe3f09.png?imageView2/0/w/800",
        "title": "区块链框架：迅雷链VS石墨烯",
        "description": "迅雷链区块链框架为区块链行业提供了一套比较完善的区块链解决方案，同样作为区块链框架，业内比较早期的石墨烯框架当时也引起了广泛的关注，它们究竟有何不同？",
        "link": "https://mp.weixin.qq.com/s/71v7JX7MKuBkfsO9mW-pZQ",
        "tip": ""
      },
      {
        "排序": "2",
        "图片": "https://static.geekbang.org/infoq/5bc07ffc2c35a.png?imageView2/0/w/800",
        "title": "划重点，深度好文：迅雷链性能提升之旅",
        "description": "为了帮助大家更好的了解共识算法的理论基础，以及迅雷链提升性能的方法，我们开设了系列专题研讨课程：《区块链共识算法的比较》。在本期推送中，我们将了解共识性能低下的其他解决方法，以及迅雷链是如何优化提升共识效率和可用性的。",
        "link": "https://mp.weixin.qq.com/s/L1a3KpDNkVF6gFlCYa_J7g",
        "tip": ""
      },
      {
        "排序": "3",
        "图片": "https://static.geekbang.org/infoq/5bc0801886b09.png?imageView2/0/w/800",
        "title": "科普：比较区块链项目中常用的共识算法",
        "description": "为了帮助大家更好的了解共识算法的理论基础，以及迅雷链提升性能的方法，我们开设了系列专题研讨课程：《区块链共识算法的比较》。在本期推送中，我们将了解共识性能低下的其他解决方法，以及迅雷链是如何优化提升共识效率和可用性的。",
        "link": "https://mp.weixin.qq.com/s/NpXwlweVxjJATLAmUo51GQ",
        "tip": ""
      },
      {
        "排序": "4",
        "图片": "https://static.geekbang.org/infoq/5bc080344634b.png?imageView2/0/w/800",
        "title": "来鑫：迅雷链解决区块链应用四大核心挑战，已具备商用能力",
        "description": "10月9日,由中国信息通信研究院、中国通信标准化协会和可信区块链推进计划联合主办的“2018可信区块链峰会”在北京召开。大会指出，未来的区块链应用将脱虚向实，让更多传统企业使用区块链技术来降成本、提升协作效率，激发实体经济增长。迅雷链总工程师来鑫，就此问题受邀作主题演讲。",
        "link": "https://mp.weixin.qq.com/s/2awMZ2tloCloH7u-ylYxRw",
        "tip": ""
      },
      {
        "排序": "5",
        "图片": "https://static.geekbang.org/infoq/5bc08045b233a.png?imageView2/0/w/800",
        "title": "区块链的可扩展性问题及解决方案对比",
        "description": "而目前主流区块链性能情况是，比特币每秒只能进行大约7笔交易；以太坊每秒10-20笔。更严重的是，目前比特币和以太坊的矿机都需要存储全量数据，而单个机器的存储容量是有限的，若按每年新增数据量47 TB算，那么这些数据很快就会超过单机的容量，到时候整个区块链网络都无法继续运行。那么，比特币和以太坊这种拥有海量节点的区块链系统，为什么性能却这么低呢？为什么区块链的可扩展性这么差呢？",
        "link": "https://mp.weixin.qq.com/s/sCM__jRigJ2rw1YD1q-2lw",
        "tip": ""
      },
      {
        "排序": "6",
        "图片": "https://static.geekbang.org/infoq/5bc0805069966.png?imageView2/0/w/800",
        "title": "玩转迅雷链开放平台：产品设计及优化一览",
        "description": "迅雷链开放平台是一个基于迅雷链主网的开放性技术平台，目前能够提供智能合约部署、链克兑换等区块链服务，其主要功能是帮助开发者更好地运用迅雷链的区块链技术，轻松进行Dapp开发和业务上链等操作。为实现这一目标，迅雷链开放平台在一开始的产品设计上，就做了很多针对性的优化，在迅雷链技术沙龙北京站的现场，迅雷链开发产品负责人马双阳就迅雷链的产品设计及优化做了详细讲解，本文对其演讲内容做了如下整理。",
        "link": "https://mp.weixin.qq.com/s/7OrPjkbVT2LvrEW4auVg8A",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      },
      {
        "排序": "",
        "图片": "",
        "title": "",
        "description": "",
        "link": "",
        "tip": ""
      }
    ]
  },
  "大会日程": {
    "是否显示": false,
    "title": {
      "h1": "大会日程全概览",
      "h2": "Agenda"
    },
    "scheduleData": [
      {
        "tab": "schedule0",
        "title": "第一天",
        "date": "10月10日"
      },
      {
        "tab": "schedule1",
        "title": "第二天",
        "date": "10月11日"
      },
      {
        "tab": "schedule2",
        "title": "第三天",
        "date": "10月12日"
      }
    ],
    "图片（pc）": "https://static.geekbang.org/infoq/5aeaa9422d08d.png",
    "图片（mobile）": "https://static.geekbang.org/infoq/5aeaa9427cfe6.png"
  },
  "讲师介绍": {
    "是否显示": false,
    "title": {
      "h1": "大咖与你相约",
      "h2": "Speaker"
    },
    "list": [
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      },
      {
        "id": "",
        "图片": "",
        "name": "",
        "company": "",
        "position": "",
        "introduce": "",
        "link": ""
      }
    ]
  },
  "会场花絮": {
    "是否显示": false,
    "title": {
      "h1": "会场花絮",
      "h2": "Live"
    },
    "list": []
  },
  "现场图片": {
    "是否显示": true,
    "title": {
      "h1": "精彩瞬间聚焦",
      "h2": "Photos"
    },
    "图片链接": [
      "https://static.geekbang.org/infoq/5c346a409e43c.png?imageView2/0/w/800",
      "https://static.geekbang.org/infoq/5c346a53f2c7f.png?imageView2/0/w/800",
      "https://static.geekbang.org/infoq/5c26dddd6bde9.png?imageView2/0/w/800",
      "https://static.geekbang.org/infoq/5c346a7334636.png?imageView2/0/w/800",
      "https://static.geekbang.org/infoq/5c346a938361c.png?imageView2/0/w/800",
      "https://static.geekbang.org/infoq/5c346ab4ceaf6.png?imageView2/0/w/800",
      "https://static.geekbang.org/infoq/5c26dd6ad459c.png?imageView2/0/w/800",
      "",
      "",
      "",
      "",
      "",
      ""
    ],
    "more": "",
    "link": "https://www.geekbang.org"
  },
  "视频回放": {
    "是否显示": false,
    "title": {
      "h1": "快览华为云掀起的技术浪潮",
      "h2": "Video"
    },
    "list": [
      {
        "图片": "https://static.geekbang.org/infoq/5bab4bc2d6a9c.png?imageView2/0/w/800",
        "title": "峰会——华为云，使能商业创新，走向智能未来 ",
        "link": "http://www.bizconfstreaming.cn/hcc2017/huawei?language=cn&email=bGl5aTMyQGh1YXdlaS5jb20="
      },
      {
        "图片": "https://static.geekbang.org/infoq/5bab4c2789a3f.png?imageView2/0/w/800",
        "title": "T-Systems助力公有云发展",
        "link": "https://www.huawei.com/cn/press-events/events/huaweiconnect2017/voices/17092001"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5bab4c61d1a65.png?imageView2/0/w/800",
        "title": "HUAWEI CONNECT2017  大会首日花絮",
        "link": "https://www.huawei.com/cn/press-events/events/huaweiconnect2017/voices/Day-One-Highlights"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde209a51ba.png?imageView2/0/w/800",
        "title": "2017云+未来峰会圆桌对话：向未来发问",
        "link": "http://daxue.qq.com/content/content/id/3470"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde20a44bc3.png?imageView2/0/w/800",
        "title": "贾佳亚：视觉AI技术以及社会价值",
        "intro": "",
        "link": "http://daxue.qq.com/content/content/id/3465"
      },
      {
        "图片": "https://static.geekbang.org/infoq/5adde209e7fb2.png?imageView2/0/w/800",
        "title": "顺丰CTO田民：科技改变物流，物流改变生活",
        "intro": "",
        "link": "http://daxue.qq.com/content/content/id/3467"
      },
      {
        "图片": "",
        "title": "",
        "intro": "",
        "link": ""
      },
      {
        "图片": "",
        "title": "",
        "intro": "",
        "link": ""
      },
      {
        "图片": "",
        "title": "",
        "intro": "",
        "link": ""
      },
      {
        "图片": "",
        "title": "",
        "intro": "",
        "link": ""
      }
    ]
  },
  "相关新闻": {
    "是否显示": false,
    "title": {
      "h1": "华为云相关新闻全播报",
      "h2": "华为云在HC大会以姿势亮相"
    },
    "list": [
      {
        "标题": "2018世界人工智能大会亮点揭秘",
        "介绍": "人工智能发展沉沉浮浮，如今再次走到风口。9月17-19日，2018世界人工智能大会将在上海西岸召开。作为服务国家战略、打造国家人工智能发展高地的重要峰会，大会将聚齐全球人工智能行业大咖，同台论道”人工智能赋能新时代”。",
        "link": "https://www.huaweicloud.com/news/2018/20180911214516491.html"
      },
      {
        "标题": "华为重庆DevCloud创新中心揭牌，助力当地打造坚实技术底座",
        "介绍": "8月23日至25日，首届中国国际智能产业博览会（以下简称“智博会“）在重庆拉开帷幕。开幕式上，习近平主席为本次大会发来贺信，同时韩正副总理亲临大会并发表重要讲话，充分体现了中共中央、国务院对智能化发展的高度重视。",
        "link": "https://www.huaweicloud.com/news/2018/20180825175622030.html"
      },
      {
        "标题": "华为云携手云庐科技，打造全球领先的工程安全监测平台",
        "介绍": "华为云携手云庐科技，通过技术合作，让工程监测变得更加轻而易举，做工程安全的“守护者”。",
        "link": "https://www.huaweicloud.com/news/2018/20180825161400852.html"
      },
      {
        "标题": "安全水平全球领先 华为云获颁BSI卓越绩效大奖",
        "介绍": "8月16日，深圳，全球权威认证机构——英国标准协会（BSI），为华为云颁发了卓越绩效大奖，以表彰华为云在安全上取得的卓越成就和对业界做出的杰出贡献。BSI中国区战略发展总监全振军为华为颁发了该奖项。",
        "link": "https://www.huaweicloud.com/news/2018/20180825154333907.html"
      },
      {
        "标题": "华为云盛大发布IPv6解决方案，海量IP让连接更简单",
        "介绍": "  9月14日，华为云中国行来到“泉城”——济南，华为EBG中国区行业云拓展部部长胡维琦在“做有信仰的云，在创新的道路上加速奔跑”的主题演讲中，谈到了对万物互联时代命题的思考，以及华为在IPv6领域数十年的沉淀。",
        "link": "https://www.huaweicloud.com/news/2018/20180919183608305.html"
      },
      {
        "标题": "世界人工智能大会华为分论坛启幕，+AI时代驱动产业智能化升级",
        "介绍": "9月19日，世界人工智能大会“+AI，驱动产业智能化升级”分论坛于上海西岸成功举办。论坛旨在探讨在云计算时代的AI技术创新发展，共商AI技术的产业化落地之道。",
        "link": "https://www.huaweicloud.com/news/2018/20180919182741500.html"
      },
      {
        "标题": "",
        "介绍": "",
        "link": ""
      },
      {
        "标题": "",
        "介绍": "",
        "link": ""
      },
      {
        "标题": "",
        "介绍": "",
        "link": ""
      },
      {
        "标题": "",
        "介绍": "",
        "link": ""
      }
    ],
    "more": {
      "name": "查看更多>>",
      "link": "https://www.huaweicloud.com/news.html"
    }
  },
  "微博话题": {
    "是否显示": false,
    "title": {
      "h1": "微博互动区",
      "h2": "Weibo"
    }
  },
  "合作伙伴": {
    "是否显示": false,
    "title": {
      "h1": "合作伙伴",
      "h2": "Partners"
    },
    "list": [
      {
        "avatar": "https://static.geekbang.org/infoq/5b9250163cb47.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "极客邦科技"
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b9252c77a567.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "华为云"
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b924fd0bf954.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "infoq"
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b9253986431b.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": ""
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b9253bd5b741.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": ""
      },
      {
        "avatar": "https://static.geekbang.org/infoq/5b92535244dcc.png?imageView2/0/w/800",
        "link": "",
        "order": "0",
        "title": "大咖说"
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      },
      {
        "avatar": "",
        "link": "",
        "order": "",
        "title": ""
      }
    ]
  },
  "关于": {
    "是否显示": true,
    "title": "关于迅雷链",
    "description": "迅雷链（Thunder Chain）是由迅雷旗下网心科技打造的超级区块链平台，是全球最大规模ToC区块链商业生态，赋能实体经济，致力于成为ToC现象级区块链应用的摇篮。基于迅雷深耕十几年，拥有多项专利的分布式技术，创造性地将共享计算和区块链相结合，具备全球领先的百万TPS高并发、秒级确认的处理能力。在迅雷链的基础上，搭建了区块链技术应用的开放平台，企业和个人开发者可以轻松将业务上链。",
    "logo": "https://static.geekbang.org/infoq/5bbdca9c38dc6.png?imageView2/0/",
    "qrcode": "https://static.geekbang.org/infoq/5bbdca4cc3309.png?imageView2/0/",
    "word": "关注迅雷链公众号"
  }
}


// WEBPACK FOOTER //
// ./src/data.js